// platform.js — single source of truth for "are we inside the Android/iOS app?"
// Everything that must behave differently in the Capacitor WebView (auth, file
// saving, cloud endpoint, back button) keys off these flags.
import { Capacitor } from '@capacitor/core';

export const isNativeApp = Capacitor.isNativePlatform();
export const platformName = Capacitor.getPlatform(); // 'web' | 'android' | 'ios'
